import './probands_samples.style.scss';

import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Input } from 'antd';
import React from 'react';

import { ActiveFilterBar } from '../../foundation/components/active_filter_bar';
import ProbandsSamplesTable from './ProbandsSamplesTable';
import { useProbandsSamplesTable } from './useProbandsSamplesTable';

const ProbandsSamplesPage = () => {
  const {
    columnFilters,
    currentPage,
    entryDateBounds,
    entryDateFrom,
    entryDateTo,
    filterOptionsData,
    getActiveFiltersCount,
    handleClearAllFilters,
    handleFilterChange,
    handleFilterClear,
    handleSearch,
    handleTableChange,
    isSamplesLoading,
    pageSize,
    samples,
    searchInput,
    setEntryDateFrom,
    setEntryDateTo,
    setSearchInput,
    totalSamples,
  } = useProbandsSamplesTable();

  return (
    <div className="probands-samples">
      <div className="probands-samples__search-wrapper">
        <Input
          prefix={<FontAwesomeIcon icon={faSearch} />}
          className="probands-samples__search-input"
          defaultValue=""
          placeholder="Search samples..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onPressEnter={handleSearch}
        />
        <Button
          className="probands-samples__search-btn"
          type="primary"
          loading={isSamplesLoading}
          onClick={handleSearch}
        >
          Search
        </Button>
      </div>

      <ActiveFilterBar
        columnFilters={columnFilters}
        dateFrom={entryDateFrom}
        dateTo={entryDateTo}
        dateLabel="Entry date"
        onFilterChange={handleFilterChange}
        onClearDateRange={() => {
          setEntryDateFrom('');
          setEntryDateTo('');
        }}
        onClearAll={handleClearAllFilters}
        getActiveFiltersCount={getActiveFiltersCount}
        classNamePrefix="probands-samples"
      />

      <ProbandsSamplesTable
        columnFilters={columnFilters}
        currentPage={currentPage}
        entryDateBounds={entryDateBounds}
        entryDateFrom={entryDateFrom}
        entryDateTo={entryDateTo}
        filterOptionsData={filterOptionsData}
        handleFilterChange={handleFilterChange}
        handleFilterClear={handleFilterClear}
        handleTableChange={handleTableChange}
        isSamplesLoading={isSamplesLoading}
        pageSize={pageSize}
        samples={samples}
        setEntryDateFrom={setEntryDateFrom}
        setEntryDateTo={setEntryDateTo}
        totalSamples={totalSamples}
      />
    </div>
  );
};

export default ProbandsSamplesPage;
